import * as React from 'react';
import styled from 'styled-components';


interface ButtonProps {
  shape?: 'normal' | 'large' | 'small' | undefined;
  color?: 'normal' | 'confirm' | 'cancel' | 'buy' | 'sell' | 'p-confirm' | 'p-cancel' | undefined;
  type?: 'button' | 'submit' | 'reset' | undefined;
  disabled?: boolean;
  onClick?: VoidFunction;
  children: React.ReactNode;
}

const ButtonStyle = ({ color = 'normal', shape = 'normal', type = 'button', children, ...props }: ButtonProps) => (
  <Button type={type} color={color} shape={shape} {...props}>
    {children}
  </Button>
);


export default ButtonStyle;


interface StyleProps {
  shape: 'normal' | 'large' | 'small' | undefined;
  color: 'normal' | 'confirm' | 'cancel' | 'buy' | 'sell' | 'p-confirm' | 'p-cancel' | undefined;
  disabled?: boolean;
  type: 'button' | 'submit' | 'reset' | undefined;
}

const Button = styled.button<StyleProps>`
  padding: 0 20px;
  border-radius: 3px;
  text-align: center;
  ${p => {
    const height = 'height:';
    let heightNum = '';
    const font = 'font-size:'
    let fontNum = '';

    switch(p.shape) {
      case 'large': heightNum = '50px'; fontNum = '18px'; break;
      case 'small': heightNum = '30px'; fontNum = '12px'; break;
      case 'normal':
      default: heightNum = '40px'; fontNum = '14px' ; break;
    }

    const resultShape = `${height}${heightNum};${font}${fontNum};`;

    const color = 'color:';
    let colorNum = '';
    const border = 'border: 1px solid ';
    let bdColorNum = '';
    const bg = 'background-color:';
    let bgColorNum = '';

    switch(p.color) {
      case 'confirm': colorNum = '#fff'; bdColorNum = '#8d7b5e'; bgColorNum = '#9b8a70'; break;
      case 'cancel': colorNum = '#fff'; bdColorNum = '#20262d'; bgColorNum = '#282f37'; break;
      case 'buy': colorNum = '#fff'; bdColorNum = '#d0451a'; bgColorNum = '#d93d00'; break;
      case 'sell': colorNum = '#fff'; bdColorNum = '#354795'; bgColorNum = '#354ba6'; break;
      case 'p-confirm': colorNum = '#666'; bdColorNum = '#cfcfcf'; bgColorNum = '#f9f9f9'; break;
      case 'p-cancel': colorNum = '#666'; bdColorNum = '#cfcfcf'; bgColorNum = '#fff'; break;
      case 'normal':
      default: colorNum = '#9f8a6d'; bdColorNum = '#b6aa92'; bgColorNum = '#fff'; break;
    }

    if (p.disabled) {
      colorNum = '#939393'; bdColorNum = '#cfcfcf'; bgColorNum = '#e5e5e5';
    }

    const resultColor = `${color}${colorNum};${border}${bdColorNum};${bg}${bgColorNum};`

    return resultShape + resultColor;
  }}

  &:hover,
  &:active {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
  }
`;


// WEBPACK FOOTER //
// ./src/styles/ui/Button.tsx